import React from 'react'
import { connect } from 'react-redux'
import { setMapReference } from '../../action/map-reference-actions'
import RenderLayers from './render-layers'
import RenderMarkers from './render-markers'
import RenderPhotos from './render-photos'
import RenderLines from './render-lines'
import RenderTracks from './render-tracks'
import RenderPolygons from './render-polygons'
import RenderCircles from './render-circles'
import { degrees2meters } from '../../lib/util'
import featureData from '../../lib/api/featureData'
import { fetchFeatureInfoFields } from '../../action/feature-field-actions'
import isNil from 'lodash/isNil'
import MapPopup from './map-popup'
import RenderFriends from './render-friends'
import LayerToggle from './layer-toggle'
import './index.scss'
import Weather from '../map/weather/index'
import Geolocation from '../map/geoLocation/index'
import ShareMarker from '../main-ui/left-toolbar/common/share-location'
import Google3DMap from '../threedmap/threedemap'
import Loader from '../hunt-planner/reusableComponents/loader/Loader'
import { selectedTabAction } from '../../action/selected-tab-action'
import { selected3dMapAction, unselected3dMapAction } from '../../action/selected-3dmap'

class Map extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      map: null,
      featureData: null,
      loadspinner: false,
      openThreeD: false,
      load3dMap: false
    }
    this.getZoomButtons = this.getZoomButtons.bind(this)
    this.doubleClicked = false
  }



  getZoomButtons() {
    const zoomContainer = document.createElement('div');
    const zoomOut = document.createElement('div');
    const zoomIn = document.createElement('div');
    const zoomInIcon = document.createElement('div');
    const zoomOutIcon = document.createElement('div');

    zoomContainer.className = 'map-zoom-container'; // Add a class for the container
    zoomIn.className = 'map-zoom-in';
    zoomOut.className = 'map-zoom-out';
    zoomOutIcon.className = 'map-zoom-out-icon';
    zoomInIcon.className = 'map-zoom-in-icon';

    zoomOut.appendChild(zoomOutIcon);
    zoomIn.appendChild(zoomInIcon);
    zoomContainer.appendChild(zoomOut); // Append zoomOut to the container
    zoomContainer.appendChild(zoomIn); // Append zoomIn to the container


    zoomIn.addEventListener('click', e => {
      e.stopPropagation();
      const zoom = this.state.map.getZoom();
      this.state.map.setZoom(zoom + 1);
    });

    zoomOut.addEventListener('click', e => {
      e.stopPropagation();
      const zoom = this.state.map.getZoom();
      this.state.map.setZoom(zoom - 1);
    });

    return zoomContainer; // Return the container instead of an array
  }
  componentDidMount() {
    this.setState(
      {
        map: new google.maps.Map(this.refs.mapContainer, {
          zoom: 4,
          center: new google.maps.LatLng({ lat: 39.71, lng: -100.21 }),
          fullscreenControl: false,
          clickableIcons: false,
          zoomControl: false,
          scaleControl: true,
          rotateControl: false,
          mapTypeControl: false,
          gestureHandling: 'greedy',
          minZoom: 3,
          mapId: "4504f8b37365c3d0",
          rotateControlOptions: {
            position: google.maps.ControlPosition.RIGHT_BOTTOM
          },
          options: {
            styles: [
              {
                featureType: 'all',
                elementType: 'labels',
                stylers: [{ visibility: 'on' }]
              }
            ]
          },
          streetViewControl: true,
          streetViewControlOptions: {
            position: google.maps.ControlPosition.RIGHT_BOTTOM
          },
          restriction: {
            latLngBounds: {
              north: 85,
              south: -85,
              west: -180,
              east: 180
            },
            strictBounds: false
          }
        })
      }, () => {
        this.props.setMapReference(this.mapReference.bind(this))
        setTimeout(() => {
          this.handleUnitPreferenceChange();
        }, 3000);
        const zoomControlsContainer = this.getZoomButtons();
        this.state.map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(zoomControlsContainer);
        this.state.map.addListener('dblclick', () => {
          this.doubleClicked = true
        })
        this.state.map.addListener('click', (e) => {

          const y = e.pixel.y;
          const x = e.pixel.x;

          const mapDivRect = this.state.map.getDiv()

          // Get the height and width of the map container
          const mapHeight = mapDivRect.offsetHeight;
          const mapWidth = mapDivRect.offsetWidth;

          // Define thresholds for the corners (adjust as needed)
          const topThreshold = mapHeight / 3;   // Top third of the map
          const bottomThreshold = mapHeight * 2 / 3;  // Bottom third of the map
          const leftThreshold = mapWidth / 3;   // Left third of the map
          const rightThreshold = mapWidth * 2 / 3;  // Right third of the map

          // console.log(topThreshold, bottomThreshold, y);

          let transformStyle = {};

          if (y < topThreshold) {
            // Top half of the map
            if (x < leftThreshold) {
              // Top-left corner
              console.log('Click is in the top-left corner.');
              transformStyle = { transform: `translate(0%, 0%)` }; // Show modal to the right
            } else if (x > rightThreshold) {
              // Top-right corner
              console.log('Click is in the top-right corner.');
              transformStyle = { transform: `translate(-100%, 0%)` }; // Show modal to the left
            } else {
              // Middle of the top third
              console.log('Click is in the middle top.');
              transformStyle = { transform: `translate(0%, 0%)` }; // Modal above the click position
            }
          } else {
            // Bottom half of the map
            if (x < leftThreshold) {
              // Bottom-left corner
              console.log('Click is in the bottom-left corner.');
              transformStyle = { transform: `translate(-2%, -99%)` }; // Show modal to the right
            } else if (x > rightThreshold) {
              // Bottom-right corner
              console.log('Click is in the bottom-right corner.');
              transformStyle = { transform: `translate(-96%, -100%)` }; // Show modal to the left
            } else {
              // Middle of the bottom third
              console.log('Click is in the middle bottom.');
              transformStyle = { transform: `translate(-2%, -99%)` }; // Modal below the click position
            }
          }

          if (this.props.featuresBlocked) {
            return
          }
          this.doubleClicked = false
          if (this.state.map.overlayMapTypes.length > 0 && this.state.featureData === null) {
            this.setState({ loadspinner: true })
            const { layersDictionary, token, fetchFeatureInfoFields, featureFields } = this.props,
              mapDivRect = this.state.map.getDiv().getBoundingClientRect(),
              zoom = this.state.map.getZoom(),
              mapBounds = this.state.map.getBounds(),
              SWD = mapBounds.getSouthWest(),
              NED = mapBounds.getNorthEast(),
              SWM = degrees2meters(SWD.lng(), SWD.lat()),
              NEM = degrees2meters(NED.lng(), NED.lat()),
              overlayLayers = [].concat(this.state.map.overlayMapTypes.getArray())
                .sort((a, b) => b.alt.drawOrder - a.alt.drawOrder),
              featureArr = overlayLayers.map(layer => {
                const layerData = layersDictionary[layer.alt.id],
                  requestUrl = `${layerData.server}` +
                    'wms?service=WMS' +
                    '&request=GetFeatureInfo' +
                    `&layers=${layerData.serverLayerName}` +
                    `&QUERY_LAYERS=${layerData.serverLayerName}` +
                    `&bbox=${SWD.lng()},${SWD.lat()},${NED.lng()},${NED.lat()}` +
                    `&width=${mapDivRect.width}` +
                    `&height=${mapDivRect.height}` +
                    '&srs=EPSG:4326' +
                    '&INFO_FORMAT=application/json' +
                    '&FEATURE_COUNT=50' +
                    `&X=${e.pixel.x}` +
                    `&Y=${e.pixel.y}`
                if (isNil(featureFields[layerData.id])) {
                  fetchFeatureInfoFields(layerData.id)
                }
                return {
                  layer: requestUrl,
                  layerId: layerData.id,
                  returnGeometry: false,
                  returnSeasonDates: true,
                  returnHarvestData: true,
                  returnPublicPhotos: true
                }
              })
            featureData.get(featureArr, zoom, token)
              .then(res => {
                this.setState({ loadspinner: false })
                if (this.doubleClicked) {
                  return
                }
                const features = []
                res.forEach(raw => {
                  raw.features.forEach(fData => {
                    fData.layerInfo = layersDictionary[raw.layer.LayerId]
                    features.push(fData)
                  })
                })
                if (features.length > 0) {
                  this.setState({
                    featureData: {
                      position: e.latLng,
                      features,
                      type: 'feature',
                      loadspinner: false,
                      transformStyle: transformStyle
                    }
                  }, () => {
                    // this.props.mapReference.setCenter(e.latLng)
                    google.maps.event.addListenerOnce(this.state.map, 'click', () => {
                      this.clearFeatureData()
                    })
                  })
                } else { }
              })
              .catch(err => {
                console.log('Feature Data Get Failed Map Click', err)
              })
          }
        })
      })

    // const adjustTop = process.env.REACT_APP_ADJUST_TOP === 'true';
    // this should be uncoment if we want 3d maps
    // const topValue = __NODE_ENV__ == 'production' ? '-130px' : '-60px';
    const topValue = this.props.selectedTab == "map" ? '-70px' : "0"
    // Create or update the style element
    let styleElement = document.getElementById('gm-style');
    if (!styleElement) {
      styleElement = document.createElement('style');
      styleElement.id = 'gm-style';
      document.head.appendChild(styleElement);
    }

    // Set the CSS rules dynamically
    styleElement.innerHTML = `
        .gm-svpc {
          left: -45px !important;
          width: 50px !important;
          height: 50px !important;
          border-radius: 50% !important;
          background-color: #1D1D1D !important;
          top: ${topValue} !important;
        }
      `;
  }

  componentDidUpdate(prevProps) {
    const { userPreferences } = this.props;
    let refContainer = this.refs.mapContainer
    // Only perform actions if the units have changed
    if (prevProps.userPreferences.units !== userPreferences.units && refContainer) {
      this.handleUnitPreferenceChange();

    }
    if (prevProps.selectedTab !== this.props.selectedTab) {
      const topValue = this.props.selectedTab == "map" ? '-70px' : "0"
      let styleElement = document.getElementById('gm-style');
      if (!styleElement) {
        styleElement = document.createElement('style');
        styleElement.id = 'gm-style';
        document.head.appendChild(styleElement);
      }

      if (this.props.selectedTab != 'map') {
        // this.onChange3d()
        this.setState({ openThreeD: false, load3dMap: false })

      }

      // Set the CSS rules dynamically
      styleElement.innerHTML = `
          .gm-svpc {
            left: -45px !important;
            width: 50px !important;
            height: 50px !important;
            border-radius: 50% !important;
            background-color: #1D1D1D !important;
            top: ${topValue} !important;
          }
        `;
    }
  }

  handleUnitPreferenceChange() {
    const { userPreferences } = this.props;
    let refContainer = this.refs.mapContainer
    if (refContainer) {

      const spans = refContainer.getElementsByTagName('span'),
        ptrnI = /\d+\s+(m|km)/i,
        ptrnM = /\d+\s+(ft|mi)/i;

      // Iterate over the spans and trigger clicks based on userPreferences.units
      for (let i = 0; i < spans.length; i++) {
        // If metric units are selected, trigger click for metric values
        if (userPreferences.units === 'metric' && ptrnM.test(spans[i].innerHTML)) {
          spans[i].click();
        }

        // If imperial units are selected, trigger click for imperial values
        if (userPreferences.units === 'imperial' && ptrnI.test(spans[i].innerHTML)) {
          spans[i].click();
        }
      }
    }
  }

  setFeatureData(featureData) {
    this.setState({ featureData })
  }

  clearFeatureData() {
    this.setState({ featureData: null })
  }

  mapReference() {
    return this.state.map
  }

  onChange3d = () => {
    this.setState({ openThreeD: !this.state.openThreeD, load3dMap: this.state.openThreeD ? this.state.load3dMap : !this.state.load3dMap }, () => {
      if (this.state.openThreeD) {
        this.props.selected3dMapAction()
      }
      else {
        this.props.unselected3dMapAction()
      }
    })
  }

  render() {
    const { leftToolbarState, rightToolbarState, userPreferences } = this.props,
      { loadspinner } = this.state,
      // mapOffset = leftToolbarState.expanded ? window.innerWidth > 1440 ? '500px' : '440px' : '78px', 
      // mapWidth = leftToolbarState.expanded ? window.innerWidth > 1440 ? 'calc(100vw - 500px)' : 'calc(100vw - 440px)' :
      //   rightToolbarState.expanded ? 'calc(100vw - 422px)' : 'calc(100vw - 78px)',
      mapWidth = this.props.width ? this.props.width : 'calc(100vw - 78px)',
      mapOffset = this.props.left ? this.props.left : '78px',
      mapHeight = this.props.height ? this.props.height : 'calc(100vh - 62px)',
      mapTopset = this.props.top ? this.props.top : '60px',

      refContainer = this.refs.mapContainer
    // return (
    //   <>
    //     <div className="map-container" style={{ height: '100vh' }}>
    //       {/* this should be un comment if we want 3d maps */}
    //       {__NODE_ENV__ == 'development' &&
    //         this.state.openThreeD &&
    //         <Google3DMap openThreeD={this.state.openThreeD} closeThis={() => { this.setState({ openThreeD: false }) }}></Google3DMap>}
    //       <div id="map" ref="mapContainer" style={{
    //         left: mapOffset,
    //         width: mapWidth,
    //         height: mapHeight,
    //         top: mapTopset
    //       }} />
    //       <ShareMarker />
    //       <Weather />
    //       <Geolocation />
    //       <LayerToggle />
    //       <RenderLayers />
    //       <RenderMarkers />
    //       <RenderPhotos />
    //       <RenderLines />
    //       <RenderTracks />
    //       <RenderPolygons />
    //       <RenderCircles />
    //       <RenderFriends
    //         clearFeatureData={this.clearFeatureData.bind(this)}
    //         setFeatureData={this.setFeatureData.bind(this)} />
    //       {this.state.featureData === null ? null :
    //         <MapPopup
    //           clearFeatureData={this.clearFeatureData.bind(this)}
    //           featureData={this.state.featureData} />}

    //       {loadspinner && <div class="loader-spinner-my-content" style={{ left: '50%' }}></div>}

    //       <button className="two-d-button" onClick={() => this.setState({
    //         openThreeD: true
    //         // !this.state.openThreeD 
    //       })}>{
    //           // !this.state.openThreeD ? '2D' : 
    //           '3D'}</button>

    //       {/* <Link to="/three-d-maps">Go to 3D Map</Link> */}

    //       {/* <button className="two-d-button">
    //         <Link to="/three-d-maps" style={{ textDecoration: 'none', color: 'inherit' }}>
    //           3D
    //         </Link>
    //       </button> */}
    //     </div>
    //   </>
    // )
    return (
      <>
        <div className="map-container" style={{ height: '100vh' }}>
          {/* 3D map rendering when enabled */}
          {__NODE_ENV__ != 'production' && this.state.openThreeD
            //  && this.props.selectedTab == "threedMap" 
            && (
              <Google3DMap
                openThreeD={this.state.openThreeD}
                markers={this.props.markers}
                photos={this.props.photos}
                polygons={this.props.polygons}
                mapReference={this.refs.mapContainer}
                onMapLoaded={() => {
                  console.log("3D map loaded.");
                }}
                load3dMap={() => this.setState({ load3dMap: false })}
              />
            )}

          {/* 2D Map Container */}
          <div
            id="map"
            ref="mapContainer"
            style={{
              left: mapOffset,
              width: mapWidth,
              height: mapHeight,
              top: mapTopset,
              display: 'block'
              // display: this.state.openThreeD ? 'none' : 'block',
            }}
          />

          {/* Render other features */}
          <ShareMarker />
          <Weather />
          <Geolocation />
          <LayerToggle />
          <RenderLayers />
          <RenderMarkers />
          <RenderPhotos />
          <RenderLines />
          <RenderTracks />
          <RenderPolygons />
          <RenderCircles />
          <RenderFriends
            clearFeatureData={this.clearFeatureData.bind(this)}
            setFeatureData={this.setFeatureData.bind(this)}
          />

          {this.state.featureData && (
            <MapPopup
              clearFeatureData={this.clearFeatureData.bind(this)}
              featureData={this.state.featureData}
            />
          )}

          {loadspinner && (
            <div className="loader-spinner-my-content" style={{ left: '50%' }} />
          )}

          {/* 3D / 2D toggle from parent */}
          {__NODE_ENV__ != 'production' &&
            <button
              className={this.state.openThreeD ? "two-d-button" : "three-d-button"}
              onClick={() => {
                this.onChange3d()
              }
              }
            >
              {this.state.openThreeD ? '2D' : '3D'}
            </button>
          }

          {this.state.load3dMap && <Loader position={'absolute'} left={'50%'} width={'30px'} dark={true}></Loader>}
        </div>
      </>
    );

  }
}

const mapStateToProps = state => ({
  featureFields: state.featureFields,
  token: state.auth.token,
  loading: state.loading,
  leftToolbarState: state.leftToolbarState,
  rightToolbarState: state.rightToolbarState,
  layersDictionary: state.layersDictionary,
  userPreferences: state.userPreferences,
  featuresBlocked: state.featuresBlocked,
  mapReference: state.mapReference(),
  selectedTab: state.selectedTab

})

const mapDispatchToProps = dispatch => ({
  fetchFeatureInfoFields: id => dispatch(fetchFeatureInfoFields(id)),
  setMapReference: map => dispatch(setMapReference(map)),
  selectedTabAction: (payload) => dispatch(selectedTabAction(payload)),
  selected3dMapAction: () => dispatch(selected3dMapAction()),
  unselected3dMapAction: () => dispatch(unselected3dMapAction())
})

export default connect(mapStateToProps, mapDispatchToProps)(Map)
